import { Sammelpunkte } from "@/backend_controller/sammelpunkte";
import { Feuerwehr } from "@/backend_controller/feuerwehr";
import Swal from "sweetalert2";

export class SammelpunkteController {
    konvKey;
    mapRef;
    bounds;
    feuerwehrID;
    partnerFeuerwehren;
    alleSammelpunkte = [];
    aktiveSammelpunkte = [];

    constructor(konvKey, mapRef, feuerwehrID, partnerFeuerwehren){
        this.konvKey = konvKey;
        this.mapRef = mapRef;
        this.feuerwehrID = feuerwehrID;
        this.partnerFeuerwehren = partnerFeuerwehren;
    }

    async init(aenderungszeitpunkt){
        await this.loadSammelpunkte(aenderungszeitpunkt);
    }

    getSammelpunkteInBounds(bounds){
        let padding = 0.01; // ca. 1000m Puffer
        const nord = bounds._northEast.lng + padding;
        const ost = bounds._northEast.lat + padding;
        const sued = bounds._southWest.lng - padding;
        const west = bounds._southWest.lat - padding;
        console.log("Bounds mit Puffer:", { nord, ost, sued, west });

        this.aktiveSammelpunkte = this.alleSammelpunkte.filter(sammelpunkt => {
            return sammelpunkt.position.y >= sued && sammelpunkt.position.y <= nord && sammelpunkt.position.x >= west && sammelpunkt.position.x <= ost;
        });

        console.log("Aktive Sammelpunkte in Bounds:", this.aktiveSammelpunkte);
        console.log(this.alleSammelpunkte);
    }

    async loadSammelpunkte(aenderungszeitpunkt){
        let response = await Sammelpunkte.get(this.konvKey);
        if(response){
            this.alleSammelpunkte = response;
            localStorage.setItem("sammelpunkte", JSON.stringify(this.alleSammelpunkte));
            localStorage.setItem("aenderungszeitpunktSammelpunkt", aenderungszeitpunkt);
        } else {
            this.alleSammelpunkte = JSON.parse(localStorage.getItem("sammelpunkte"));
        }
    }

    async addSammelpunkt(x, y){

        let html = `<input id="beschreibung" type="text" class="swal2-input" placeholder="Beschreibung" style="margin-left:0 !important; margin-right: 0 !important; width: 100% !important"><br>`;

        const { value: formValues } = await Swal.fire({
            title: 'Neuen Sammelpunkt hinzufügen',
            html: html,
            focusConfirm: false,
            preConfirm: () => {
                const beschreibung = document.getElementById('beschreibung').value;
                return { beschreibung };
            }
        });
        if(formValues){
            console.log("Formularwerte:", formValues);
            let response = await Sammelpunkte.add(x, y, formValues.beschreibung, this.feuerwehrID);
            if(response){
                let neuerSammelpunkt = {
                    id: response.id,
                    position: { x: x, y: y },
                    beschreibung: formValues.beschreibung,
                    feuerwehrID: this.feuerwehrID
                };
                console.log(neuerSammelpunkt);
                this.alleSammelpunkte.push(neuerSammelpunkt);
                this.aktiveSammelpunkte.push(neuerSammelpunkt);
                localStorage.setItem("sammelpunkte", JSON.stringify(this.alleSammelpunkte));
                let response2 = await Feuerwehr.updateAenderungszeiger(this.feuerwehrID);
                console.log("Aenderungszeiger aktualisiert:", response2);
                Swal.fire({
                    icon: 'success',
                    title: 'Erfolg',
                    text: 'Der Sammelpunkt wurde erfolgreich hinzugefügt.',
                });
            }
        }
    }

    async deleteSammelpunkt(id){
        await Swal.fire({
            title: 'Bist du sicher?',
            text: "Möchtest du diesen Sammelpunkt wirklich löschen?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ja, löschen!',
            cancelButtonText: 'Abbrechen'
        }).then(async (result) => {
            if (result.isConfirmed) {
                let response = await Sammelpunkte.delete(id, this.feuerwehrID);
                if(response){
                    this.alleSammelpunkte = this.alleSammelpunkte.filter(sammelpunkt => sammelpunkt.id !== id);
                    this.aktiveSammelpunkte = this.aktiveSammelpunkte.filter(sammelpunkt => sammelpunkt.id !== id);
                    localStorage.setItem("sammelpunkte", JSON.stringify(this.alleSammelpunkte));
                    let response2 = await Feuerwehr.updateAenderungszeiger(this.feuerwehrID);
                    console.log("Aenderungszeiger aktualisiert:", response2);
                    Swal.fire({
                        icon: 'success',
                        title: 'Gelöscht',
                        text: 'Der Sammelpunkt wurde erfolgreich gelöscht.',
                    });
                }
            }
        });
    }

    async editSammelpunkt(sammelpunktObj){

        let html = `<input id="beschreibung" type="text" class="swal2-input" placeholder="Beschreibung" value="${sammelpunktObj.beschreibung}" style="margin-left:0 !important; margin-right: 0 !important; width: 100% !important"><br>`;

        const { value: formValues } = await Swal.fire({
            title: 'Sammelpunkt bearbeiten',
            html: html,
            focusConfirm: false,
            preConfirm: () => {
                const beschreibung = document.getElementById('beschreibung').value;
                return { beschreibung };
            }
        });
        if(formValues){
            console.log("Formularwerte:", formValues);
            let response = await Sammelpunkte.update(sammelpunktObj.id, sammelpunktObj.position.x, sammelpunktObj.position.y, formValues.beschreibung, this.feuerwehrID);
            if(response){
                let bearbeiteterSammelpunkt = {
                    id: sammelpunktObj.id,
                    position: { x: sammelpunktObj.position.x, y: sammelpunktObj.position.y },
                    beschreibung: formValues.beschreibung,
                    feuerwehrID: this.feuerwehrID
                };
                console.log(response);
                this.alleSammelpunkte = this.alleSammelpunkte.map(sammelpunkt => {
                    if(sammelpunkt.id === bearbeiteterSammelpunkt.id){
                        return bearbeiteterSammelpunkt;
                    }
                    return sammelpunkt;
                });
                this.aktiveSammelpunkte = this.aktiveSammelpunkte.map(sammelpunkt => {
                    if(sammelpunkt.id === bearbeiteterSammelpunkt.id){
                        return bearbeiteterSammelpunkt;
                    }
                    return sammelpunkt;
                });
                localStorage.setItem("sammelpunkte", JSON.stringify(this.alleSammelpunkte));
                let response2 = await Feuerwehr.updateAenderungszeiger(this.feuerwehrID);
                console.log("Aenderungszeiger aktualisiert:", response2);
                Swal.fire({
                    icon: 'success',
                    title: 'Erfolg',
                    text: 'Der Sammelpunkt wurde erfolgreich bearbeitet.',
                });
            }
        }
    }
}